// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__JJ0TU","paymentContainer":"PaymentPage_paymentContainer__17Re3"};